import { SelectOptionTitleContainer } from "./styles"
import { SelectOptionTitleProps } from "./types"

export const SelectOptionTitle = ({ text }: SelectOptionTitleProps) => (
  <SelectOptionTitleContainer>{text}</SelectOptionTitleContainer>
)
